<h2 class="mb-4 mt-4">
  {{ "setMsGraphOptions" | transloco }}
</h2>
<div class="mb-4">
  <app-tenant-ms-graph-edit-form
    [msGraphOptions]="msGraphOptions"
    [tenantId]="tenantId"
    (optionsSubmit)="updateCreateMsGraphOptions($event)"
  >
  </app-tenant-ms-graph-edit-form>
</div>
